WiseMetering.Views.ShowWiseApiIntegration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integrations/wise_api/show',
    title: () => i18next.t('modal.title.integrations.show'),

    edit: function() {
        new WiseMetering.Views.EditWiseApiIntegration({ model: this.model });
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            configuration: this.model.configuration(),
            site: this.model.site()
        };
    }
});
